import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ApplyJobListAction } from "./../../Redux/action/ApplyJobListAction";
import { SendRequestAction } from "./../../Redux/action/SendRequestAction";
import { TeamTableAction } from "../../Redux/action/TeamTableAction";
import NewScheduleInterview from "../Vendor/interview/NewScheduleInterview";
import { ToastContainer, toast } from "react-toastify";
import TableHeader from "../Common/TableHeader";
import { FaRegCalendarCheck } from "react-icons/fa";
import { TbExternalLink } from "react-icons/tb";
import RescheduleInterviewModal from "./RescheduleInterviewModal";
import { SpinLoader } from "./ImportCandidates";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextareaAutosize } from "@mui/material";
import DeactivateModal from "../Common/DeactivateMemberModal";
import axios from "axios";
import BackButton from "../Common/BackButton/BackButton";

const ApplyJobList = () => {
    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(20);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [search, setSearch] = useState("");

    const [selectedReason, setSelectedReason] = useState(""); // To store the selected reason
    const [otherReason, setOtherReason] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [showOtherTextarea, setShowOtherTextarea] = useState(selectedReason === "other");

    const [componentKey, setComponentKey] = useState(0);

    const [open, setOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [canInfo, setCanInfo] = useState('');

    const [jobId, setJobId] = useState("");
    const [vendorid, setVendorId] = useState("");
    const [appliedJobsId, setAppliedJobsId] = useState("");
    const [candidateId, setCandidateId] = useState("");


    const userInfo = useSelector((state) => state?.ApplyJobList?.result?.content);
    // const TeamList = useSelector((state) => state.TeamTable.result);

    // console.log('APPLY INFO------', TeamList);
    const { userResult } = useSelector((state) => state.Auth);
    let { id } = useParams();
    let vendorId = userResult?.vendorid;
    const dispatch = useDispatch(); 
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(ApplyJobListAction(id));
    }, []);

    const onRequest = (candidateId, jobId, appliedJobsId) => {
        const data = { appliedJobsId };
        dispatch(SendRequestAction(data));
    };

    const Loading = useSelector((state) => state.SendRequestData.loading);

    const handleClick = (e) => {
        setcurrentPage(Number(e.target.id));
    };

    const pages = [];
    for (let i = 1; i <= Math.ceil(userInfo?.length / itemsPerPage); i++) {
        pages.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userInfo?.slice(indexOfFirstItem, indexOfLastItem);
    const newData = userInfo;

    const baseUrl = process.env.REACT_APP_API_PATH;

    const renderPageNumbers = pages.map((number) => {
        if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
            return (
                <li
                    key={number}
                    id={number}
                    onClick={handleClick}
                    className={currentPage === number ? "active" : null}
                >
                    {number}
                </li>
            );
        } else {
            return null;
        }
    });

    const handleNextbtn = () => {
        setcurrentPage(currentPage + 1);
        if (currentPage + 1 > maxPageNumberLimit) {
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    };

    const handlePrevbtn = () => {
        setcurrentPage(currentPage - 1);
        if ((currentPage - 1) % pageNumberLimit === 0) {
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    };

    let pageIncrementBtn = null;
    if (pages?.length > maxPageNumberLimit) {
        pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
    }

    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
        pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
    }

    const handleSchedule = (item) => {
        setCanInfo(item);
        setOpen(true)
    }

    const handleReasonChange = (event) => {
        const value = event.target.value;
        setSelectedReason(value);

        // If "other" is selected, show the textarea
        setShowOtherTextarea(value === "other");
    };

    const handleOtherReasonChange = (event) => {
        setOtherReason(event.target.value);
    };

    const openModal = (appliedJobsId, jobId, vendorId, candidateId) => {
        setIsModalOpen(true);
        setJobId(appliedJobsId)
        setAppliedJobsId(jobId)
        setVendorId(vendorId)
        setCandidateId(candidateId)
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setJobId("")
        setAppliedJobsId("")
        setVendorId("")
    };

    // console.log('JOB ID --' , jobId)
    // console.log('ALL DATA--------- --' , currentItems)


    const handleSubmit = async (e) => {
        // console.log("first",selectedReason)
        e.preventDefault();
        if (!selectedReason) {
            return toast.error("Please select one option");
        }

        // Check if "other" is selected but no reason is provided
        if (selectedReason === "other" && (!otherReason || otherReason.trim() === "")) {
            return toast.error("Please provide a reason in the 'Other' field");
        }

        setLoading(true)

        try {
            const content = {
                declinedReason: selectedReason !== 'other' ? selectedReason : otherReason,
                appliedJobsId: jobId,
                jobAcceptanceStatus: "REJECTED",
                vendorId: vendorid || null,
                jobId: appliedJobsId,
                candidateId: candidateId,
            }
            const response = await axios.put(`${baseUrl}/ebench/update_applied_job_status`, content, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            dispatch(ApplyJobListAction(id));
            const data = await response.data;
            // console.log("OOOOO!!!",data);
            if (data) {
                setTimeout(() => {
                    toast.success("Candidate Rejected Successfull")
                }, 1000)
            }
            setLoading(false)
            setSelectedReason("")
            // setSelectedCandidates([])
            closeModal();
            setOtherReason("")
            setComponentKey((prevKey) => prevKey + 1);
        } catch (error) {
            setLoading(false)
            console.error("Error occurred", error);
            toast.error(error.response.data.status.message);
        }

    }

    return (
        <div>
            <ToastContainer />
            <div
                className="common_wrapper mt-4"
            >
                {/* <TableHeader heading={'Applied Job List'} /> */}
                <div className="card-header common_table_header">
                    Applied Candidates List
                </div>
                <div className="card-body table-responsive">
                    <table className="table-data" style={{ fontSize: '14px' }}>
                        <thead>
                            <tr>
                                <th className="fw_600" scope="col">Candidate Id</th>
                                <th className="fw_600" scope="col">Name</th>
                                <th className="fw_600" scope="col">Designation</th>
                                {/* <th className="fw_600" scope="col">Key Skills</th> */}
                                {/* <th className="fw_600" scope="col">Candidate Status</th> */}
                                <th className="fw_600" scope="col">Rejected Reason </th>
                                {/* <th className="fw_600" scope="col">Job Request</th> */}
                                <th className="fw_600" scope="col">Interview Status</th>
                                <th className="fw_600" scope="col">Schedule Interview</th>
                                <th className="fw_600" scope="col">View Profile</th>
                                <th className="fw_600" scope="col">Reject</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems &&
                                currentItems.map((item, i) => {
                                    return (
                                        <>
                                            <tr key={i}>
                                                <td>{item.candidateEmpId}</td>
                                                <td>{item.candidateName}</td>
                                                <td>{item.jobTitle}</td>
                                                {/* <td>{item.skills}</td> */}
                                                {/* {item.jobAcceptanceStatus === "ACCEPTED" ? (
                                                    <td >
                                                        <button className="applyJob_acceptBtn">Accepted By Candidate</button>
                                                    </td>
                                                ) : item.jobAcceptanceStatus === "REJECTED" ? (
                                                    <td>
                                                        <button className="applyJob_rejBtn">Rejected By Candidate</button>
                                                    </td>
                                                ) : <td>
                                                    <button className="applyJob_rejBtn">Job Request Pending</button>
                                                </td>} */}
                                                {item.jobAcceptanceStatus === "REJECTED" ? <><td>{item?.declinedReason ?? 'N/A'}</td></> : <><td>N/A</td></>}
                                                {/* <td>{item.jobAcceptanceStatus }</td> */}
                                                <td>
                                                    <div className={`w-75 m-auto mb-0 
                                                            ${item.jobAcceptanceStatus === 'REJECTED' ? 'red_status'
                                                            : item.jobAcceptanceStatus === 'INTERVIEW_SCHEDULED' ? 'green_status'
                                                                : 'yellow_status'}`}>
                                                        {item.jobAcceptanceStatus === 'REJECTED' ? 'Rejected'
                                                            : item.jobAcceptanceStatus === 'INTERVIEW_SCHEDULED' ? 'Scheduled'
                                                                : item.jobAcceptanceStatus === 'PENDING' ? 'Pending'
                                                                    : 'N/A'}
                                                    </div>
                                                </td>

                                                {item.jobAcceptanceStatus === "PENDING" ? (
                                                    <td >
                                                        <div style={{ padding: "2px", backgroundColor: "transparent" }} variant="contained" onClick={() => handleSchedule(item)}>
                                                            <NewScheduleInterview department={item?.department} CID={item.candidateId} jobId={item.jobId} item={item} />
                                                            {/* Schedule */}
                                                        </div>
                                                    </td>
                                                ) : (
                                                    <td
                                                        onClick={() => {
                                                            onRequest(item.candidateId, item.jobId, item.appliedJobsId);
                                                        }}
                                                    >
                                                        {/* {Loading ? <Button style={{ padding: "9px", background: "#1c6597" }} variant="contained" >
                                                            Loading ....
                                                        </Button> : <Button style={{ padding: "9px", background: "#1c6597" }} variant="contained" >
                                                            Job Request
                                                        </Button>} */}
                                                        <FaRegCalendarCheck
                                                            size={24}
                                                            color={item.jobAcceptanceStatus === 'REJECTED' || item.jobAcceptanceStatus === 'INTERVIEW_SCHEDULED' ? '#808080' : '#286a94'}
                                                            className={`pointer ${(item.jobAcceptanceStatus === 'REJECTED' || item.jobAcceptanceStatus === 'INTERVIEW_SCHEDULED') && 'cursor_disabled'}`} />

                                                    </td>
                                                )}
                                                <td>
                                                    <Link
                                                        to={`/applied-candidate-view/${item.candidateId}`}
                                                        state={{ id: item.candidateId, user: "user" }}
                                                    >
                                                        {/* <Button style={{ padding: "8px", background: "#1c6597" }} variant="contained">
                                                            View Profile
                                                        </Button> */}

                                                        <TbExternalLink size={24} color='#286a94' />
                                                    </Link></td>

                                                <td className={`pointer ${(item.jobAcceptanceStatus === 'REJECTED' || item.jobAcceptanceStatus === 'INTERVIEW_SCHEDULED') && 'cursor_disabled'}`}>
                                                    {item.jobAcceptanceStatus === 'REJECTED' ? <span className="text-danger fw-normal">Rejected</span> :
                                                        (
                                                            <button className="btn btn-outline-danger" disabled={(item.jobAcceptanceStatus === 'REJECTED' || item.jobAcceptanceStatus === 'INTERVIEW_SCHEDULED')} onClick={() => openModal(item.appliedJobsId, item.jobId, item?.vendorId, item?.candidateId)}>
                                                                Reject
                                                            </button>
                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        </>
                                    );
                                })}
                        </tbody>
                    </table>
                    {
                        currentItems?.length === 0 &&
                        <div style={{ textAlign: 'center', paddingTop: 10 }}>
                            No Data Available
                        </div>
                    }

                    {/* <RescheduleInterviewModal open={open} setOpen={setOpen}  data={TeamList} CID={canInfo.candidateId} jobId={canInfo.jobId} /> */}

                </div>
                {userInfo?.length >= 5 ? (
                    <div className="mt-4">
                        <ul className="pageNumbers">
                            <li>
                                <button
                                    onClick={handlePrevbtn}
                                    disabled={currentPage === pages[0] ? true : false}
                                >
                                    Prev
                                </button>
                            </li>
                            {pageDecrementBtn}
                            {renderPageNumbers}
                            {pageIncrementBtn}
                            <li>
                                <button
                                    onClick={handleNextbtn}
                                    disabled={
                                        currentPage === pages[pages?.length - 1] ? true : false
                                    }
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </div>
                ) : (
                    ""
                )}
            </div>

            <DeactivateModal isOpen={isModalOpen} onClose={closeModal} heading={'Reason for Rejection'} >
                <FormControl>
                    <FormLabel id="demo-radio-buttons-group-label">Reasons</FormLabel>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        name="radio-buttons-group"
                        value={selectedReason}
                        onChange={handleReasonChange}
                    >
                        <FormControlLabel className='mb-2' value="Not the right fit for the position" control={<Radio />} label="Not the right fit for the position" />

                        <FormControlLabel className='mb-2' value="Lack of Qualifications" control={<Radio />} label="Lack of Qualifications" />

                        <FormControlLabel className='mb-2' value="Position Already Filled" control={<Radio />} label="Position Already Filled" />


                        <FormControlLabel className='mb-2' control={<Radio />} value={'other'} label="Others"
                        //  onClick={handleOtherReason}
                        />

                        {showOtherTextarea && (
                            <TextareaAutosize
                                value={otherReason}
                                onChange={handleOtherReasonChange}
                                placeholder="Other Reason"
                                minRows={5}
                                maxRows={5}
                            />
                        )}
                    </RadioGroup>


                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            variant="contained"
                            className="common_btn"
                            style={{
                                background: '#1c6597', color: '#fff', marginRight: '10px', width: "100px",
                                height: "40px",
                            }}
                            onClick={handleSubmit} // Add your submit logic here
                        >
                            {!loading ? "Submit" : <SpinLoader />}
                        </button>

                        {/*
                                 <button
                                    className="btn btn-danger rounded-0"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </button> 
                                */}
                    </div>
                </FormControl>
            </DeactivateModal>
        </div>
    );
};

export default ApplyJobList;
